import { render, staticRenderFns } from "./InquiryInfo.vue?vue&type=template&id=abc70486&scoped=true&"
import script from "./InquiryInfo.vue?vue&type=script&lang=ts&"
export * from "./InquiryInfo.vue?vue&type=script&lang=ts&"
import style0 from "./InquiryInfo.vue?vue&type=style&index=0&id=abc70486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc70486",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VContainer,VSimpleTable})
